import i18next from 'i18next'

export const translateValidator = (validator, localeKey) => (...values) => {
  const isValid = validator(...values)
  return !isValid ? i18next.t(localeKey, mapValues(values)) : undefined
}

function mapValues(values: any[]) {
  const result = {}

  values.forEach((value, index) => (result[`value_${index}`] = value))

  return result
}

export const t = i18next.t
